import reducers from './reducers';
import sagas from './sagas';

export default {
    reducers,
    sagas,
};
